module.exports = __webpack_public_path__ + "img/100-lat.c6e42a44.svg";